import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { CustomCodeService } from '@app/shared/services/custom-codes/custom-code.service';
import { QuestionService } from '@app/shared/services/questions/question.service';
import { RuleService } from '@app/shared/services/rule/rule.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-add-new-rule',
  templateUrl: './dialog-add-new-rule.component.html',
  styleUrls: ['./dialog-add-new-rule.component.scss', './dialog-add-new-rule.component.mobile.scss'],
})
export class DialogAddNewRuleComponent implements OnInit {
  intents: any[];
  loadingIntents: boolean;
  creating: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogAddNewRuleComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public authService: AuthenticationService,
    private ruleService: RuleService,
    private router: Router,
    private customCodeService: CustomCodeService,
    private questionService: QuestionService
  ) { }

  ngOnInit() {
    this.getListOfIntents();
  }

  getListOfIntents() {
    this.loadingIntents = true;
    this.questionService.getIntents().subscribe((res) => {
      this.intents = res.data;
      this.loadingIntents = false;
    });
  }

  dismissModal() {
    this.dialogRef.close();
  }

  eventTypeToString(eventType: string): { name: string; url: string } {
    switch (eventType) {
      case 'inquiry':
        return {
          name: 'New booking inquiry',
          url: '/gx/rule',
        };

      case 'preapproved':
        return {
          name: 'New pre-approval',
          url: '/gx/rule',
        };

      case 'pending':
        return {
          name: 'New booking request',
          url: '/gx/rule',
        };

      case 'accepted':
        return {
          name: 'New booking accepted',
          url: '/gx/rule',
        };

      case 'cancelled':
        return {
          name: 'New cancellation',
          url: '/gx/rule',
        };

      case 'timedout':
        return {
          name: 'Pre-approval expired',
          url: '/gx/rule',
        };

      case 'denied':
        return {
          name: 'Booking denied',
          url: '/gx/rule',
        };

      case 'special_offer':
        return {
          name: 'New special offer',
          url: '/gx/rule',
        };

      case 'awaiting_payment':
        return {
          name: 'Payment issues',
          url: '/gx/rule',
        };

      case 'scheduled:accepted':
        return {
          name: 'After a new reservation',
          url: '/gx/rule',
        };

      case 'checkin':
        return {
          name: 'Scheduled check-in',
          url: '/gx/rule',
        };

      case 'checkout':
        return {
          name: 'Scheduled check-out',
          url: '/gx/rule',
        };

      case 'recurring:weekly':
        return {
          name: 'Scheduled day of the week',
          url: '/gx/rule',
        };

      case 'review':
        return {
          name: 'Review a guest',
          url: '/gx/reviews/review',
        };

      case 'static:canned':
        return {
          name: 'New canned response',
          url: '/gx/canned-responses/resp',
        };

      case 'checkpoint':
        return {
          name: 'Reply to identity confirmation',
          url: '/gx/rule',
        };

      default:
        return {
          name: 'New booking inquiry',
          url: '/gx/rule',
        };
    }
  }

  createRule(eventType: string, before = false) {
    this.creating = true;

    const eventData = this.eventTypeToString(eventType);
    const payload: any = {
      name: eventData.name,
      event: eventType,
      all_platforms: true,
      all_hosts: true,
      all_properties: true,
      mode: 'offensive',
    };

    if (eventType === 'review') {
      payload.time = '1d';
    }

    if (before) {
      payload.time = '-1d';
    }

    this.ruleService.createRuleset(payload).subscribe(
      (res) => {
        this.creating = false;
        if (res.data.id) {
          this.router.navigate([eventData.url, res.data.id]);
          this.dialogRef.close();
        }
      },
      (err) => {
        this.creating = false;
      }
    );
  }

  createQuestionRule(intent: any) {
    this.creating = true;

    const payload = {
      name: `Reply to questions about ${intent.name}`,
      event: `question:${intent.intent}`,
      all_platforms: true,
      all_hosts: true,
      all_properties: true,
      mode: 'passive',
    };

    this.ruleService.createRuleset(payload).subscribe(
      (res) => {
        this.creating = false;

        if (res.data.id) {
          this.router.navigate(['/gx/rule', res.data.id]);
          this.dialogRef.close();
        }
      },
      (err) => {
        this.creating = false;
      }
    );
  }

  createCustomCode() {
    this.creating = true;

    const payload = {
      all_conditions: true,
      all_hosts: true,
      all_platforms: true,
      all_properties: true,
      key: this.makeid(8),
      text: 'Your custom code text here..',
      new_design: true,
    };
    this.customCodeService.createCustomCode(payload).subscribe(
      (res: any) => {
        this.creating = false;

        if (res.data.id) {
          this.router.navigate(['/gx/custom-codes/code', res.data.id]);
          this.dialogRef.close();
        }
      },
      (err) => {
        this.creating = false;
      }
    );
  }

  makeid(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
